/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

   console.log('hi');
 if (typeof window.IntersectionObserver !== 'undefined') {
      let options = {
          threshold: [0.5, 1]
      }
      const targets = document.querySelectorAll('.cb');
      const locker = document.querySelector('.locker__container');
      function handleIntersection(entries) {
          entries.map((entry) => {
              if (entry.isIntersecting) {
                  entry.target.current = entry.target.dataset.swap;
                  document.querySelector(".locker__container ." + entry.target.current).classList.add("active");
              } else {
                  document.querySelector(".locker__container ." + entry.target.current).classList.remove("active");
              }
          });
      }
      const observer = new IntersectionObserver(handleIntersection, options);
      targets.forEach(target => observer.observe(target));
  } else {
      // Fallback
  }

document.addEventListener('DOMContentLoaded', function() {
    var flkty = new Flickity('.carousel', {
      // Flickity options
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      // Add any other options you need
    });
  });



  /* ==========================================
   MOS - Strict Search Form Submission
   Title OR Tag + Available Products
========================================== */

(function () {
  'use strict';

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form || form.tagName !== 'FORM') return;

    var queryInput = form.querySelector('input[name="q"]');

    if (!queryInput) return;

    var action = form.getAttribute('action') || '';

    // Only target storefront search forms
    var searchPath = window.routes && window.routes.searchUrl
      ? window.routes.searchUrl
      : '/search';

    if (action && action.indexOf('/search') === -1 &&
        action.indexOf(searchPath) === -1) {
      return;
    }

    var rawQuery = queryInput.value.trim();

    if (!rawQuery) return;

    // Shopify receives strict title/tag search syntax.
    queryInput.value = window.mosStrictSearchQuery(rawQuery);

    // Ensure only product results are requested
    var typeInput = form.querySelector('input[name="type"]');

    if (!typeInput) {
      typeInput = document.createElement('input');
      typeInput.type = 'hidden';
      typeInput.name = 'type';
      form.appendChild(typeInput);
    }

    typeInput.value = 'product';

    // Hide unavailable products
    var unavailableInput = form.querySelector(
      'input[name="options[unavailable_products]"]'
    );

    if (!unavailableInput) {
      unavailableInput = document.createElement('input');
      unavailableInput.type = 'hidden';
      unavailableInput.name = 'options[unavailable_products]';
      form.appendChild(unavailableInput);
    }

    unavailableInput.value = 'hide';

    // Disable prefix expansion
    var prefixInput = form.querySelector(
      'input[name="options[prefix]"]'
    );

    if (!prefixInput) {
      prefixInput = document.createElement('input');
      prefixInput.type = 'hidden';
      prefixInput.name = 'options[prefix]';
      form.appendChild(prefixInput);
    }

    prefixInput.value = 'none';

  }, true);

})();
